import React from "react";

import { useCoffreFortSettings } from "./hooks/useCoffreFortSettings";

import CoffreFortHeader from "./components/CoffreFortHeader";
import CoffreFortKpiCards from "./components/CoffreFortKpiCards";
import CoffreFortSegmentsShell from "./components/CoffreFortSegmentsShell";
import CoffreSegmentCreateDrawer from "./components/CoffreSegmentCreateDrawer";

export default function SettingsCoffreFort() {
  const dashboard = useCoffreFortSettings();

  return (
    <div className="space-y-5">
      <CoffreFortHeader
        loading={dashboard.loading}
        onRefresh={dashboard.fetchSegments}
        onCreate={dashboard.openCreateDrawer}
      />

      {/* <CoffreFortKpiCards
        stats={dashboard.stats}
        loading={dashboard.loading}
      /> */}

      <CoffreFortSegmentsShell
        segments={dashboard.segments}
        filteredSegments={dashboard.filteredSegments}
        activeSegment={dashboard.activeSegment}
        activeSegmentId={dashboard.activeSegmentId}
        setActiveSegmentId={dashboard.setActiveSegmentId}
        search={dashboard.search}
        setSearch={dashboard.setSearch}
        loading={dashboard.loading}
        savingSegmentId={dashboard.savingSegmentId}
        deletingSegmentId={dashboard.deletingSegmentId}
        fileForms={dashboard.fileForms}
        fileToEditId={dashboard.fileToEditId}
        savingFileId={dashboard.savingFileId}
        deletingFileId={dashboard.deletingFileId}
        onSegmentChange={dashboard.handleLocalSegmentChange}
        onSaveSegment={dashboard.handleSaveSegment}
        onDeleteSegment={dashboard.handleDeleteSegment}
        onFileChange={dashboard.handleFileChange}
        onEditFile={dashboard.handleEditFile}
        onResetFileForm={dashboard.resetFileForm}
        onSaveFile={dashboard.handleSaveFile}
        onDeleteFile={dashboard.handleDeleteFile}
        onCreate={dashboard.openCreateDrawer}
      />

      <CoffreSegmentCreateDrawer
        isOpen={dashboard.createDrawerOpen}
        submitting={dashboard.creatingSegment}
        newSegment={dashboard.newSegment}
        setNewSegment={dashboard.setNewSegment}
        newFormKey={dashboard.newFormKey}
        onClose={dashboard.closeCreateDrawer}
        onSubmit={dashboard.handleAddSegment}
        onReset={dashboard.resetNewSegment}
      />
    </div>
  );
}